import React from 'react';
import './style.css'
import { Modal } from 'react-bootstrap';

const HistoricoModal = ({ show, onHide, historico }: any) => {
    if (!historico) {
        return <></>; // Ou outra mensagem de erro ou loading apropriada
    }

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };

    // Filtrar duplicatas de função e GHE
    const filteredHistorico = historico.filter((item: any, index: number, self: any) => 
        index === self.findIndex((t: any) => 
            t.funcao.AteBaseFuncao.nome === item.funcao.AteBaseFuncao.nome && 
            t.funcao.pgrGhe.nome === item.funcao.pgrGhe.nome
        )
    );

    // Extrai e ordena IDs únicos das revisões
    const uniqueRevisaoIds = Array.from(new Set(filteredHistorico.map((item: any) => item.revisao.id))).sort((a: any, b: any) => a - b);
    // Mapeia os IDs para a sequência 1, 2, 3, ...
    const revisaoIdMapping: any = uniqueRevisaoIds.reduce((acc: any, currentId: any, index: any) => {
        acc[currentId] = index + 1;
        return acc;
    }, {});

    let lastRevisaoId: any = null;
    let lastUpdatedAt: any = null;
    let revisaoIdCounter: any = 0;
    const revisaoIdRowsToSpan: any = {};

    filteredHistorico.forEach((item: any, index: any) => {
        if (item.revisao.id !== lastRevisaoId) {
            lastRevisaoId = item.revisao.id;
            revisaoIdCounter = 1;
            revisaoIdRowsToSpan[index] = revisaoIdCounter;
        } else {
            revisaoIdCounter++;
            revisaoIdRowsToSpan[index - revisaoIdCounter + 1] = revisaoIdCounter;
        }
    });

    return (
        <Modal show={show} onHide={onHide} size="lg" className="historico-modal">
            <Modal.Header closeButton>
                <div>
                    <Modal.Title>Histórico</Modal.Title>
                    <div className="modal-subtitle">Inclusão das seguintes funções nesta revisão</div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <table>
                    <thead>
                        <tr>
                            <th>Revisão</th>
                            <th>Oficialização</th>
                            <th>Descrição da Função</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredHistorico.map((item: any, index: number) => {
                            const newRevisaoId = revisaoIdMapping[item.revisao.id];
                            const isDifferentRevisaoId = lastRevisaoId !== newRevisaoId;
                            const isDifferentUpdatedAt = lastUpdatedAt !== item.revisao.updated_at;
                            const rowStyle = isDifferentRevisaoId && index !== 0 ? { borderTop: '2px solid #000' } : {};

                            const revisaoIdDisplay = isDifferentRevisaoId ? newRevisaoId : '';
                            const updatedAtDisplay = isDifferentUpdatedAt ? formatDate(item.revisao.updated_at) : '';

                            lastRevisaoId = newRevisaoId;
                            lastUpdatedAt = item.revisao.updated_at;
                            const rowSpan = revisaoIdRowsToSpan[index] || 0;

                            return (
                                <tr key={item.id} style={rowStyle}>
                                    {rowSpan > 0 && (
                                        <td rowSpan={rowSpan}>{newRevisaoId}</td>
                                    )}
                                       {rowSpan > 0 && (
                                        <td rowSpan={rowSpan}>{updatedAtDisplay}</td>
                                    )}
                                    <td>{item.funcao.AteBaseFuncao.nome} no {item.funcao.pgrGhe.nome}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </Modal.Body>
        </Modal>
    );
};

export default HistoricoModal;
